export default {
  /**
   * 数组去重
   * @param {*} arr 数组
   * @param {*} key 去重key值
   */
  duplicateList (arr, key) {
    let obj = {}
    arr = arr.reduce((item, next) => {
      if (!obj[next[key]]) {
        item.push(next)
        obj[next[key]] = true
      }
      return item
    }, [])
    return arr
  },

  /**
   * 搜索树
   * @param {*} key 搜索匹配字段，如name
   * @param {*} primary 数组去重字段 唯一
   * @param {*} value 搜索字段
   * @param {*} arr 树列表
   * @returns 
   */
  searchTree (key, primary, value, arr) {
    let newarr = []
    arr.forEach((item) => {
      if (item.children && item.children.length) {
        const child = this.duplicateList(this.searchTree(key, primary, value, item.children), primary)
        const obj = { ...item, expand: true, children: child, }
        if (child && child.length) {
          newarr.push(obj)
        } else if (item[key].indexOf(value) > -1) {
          item.expand = true
          newarr.push(item)

        }
      } else {
        if (item[key].indexOf(value) > -1) {
          newarr.push(item)
        }
      }
    })
    return newarr
  },

  /**
   * 回显已选中的树
   * @param {*} key 判断是否选择的字段
   * @param {*} data 树
   * @param {*} list 已选中列表
   * @returns 
   */
  getCheckedTree (key, data, list) {
    data.forEach((item) => {
      if (list.filter((it) => { return it[key].toString() == item[key].toString() }).length > 0) {
        item.checked = true
      } else {
        item.checked = false
      }
      if (item.children && item.children.length) {
        item.children = this.getCheckedTree(key, item.children, list)
      }
    })
    return data
  },
  /**
   * 仅通过ID列表回显已选中的树
   * @param {*} data 树
   * @param {*} list 已选中列表
   * @param {*} checkedList 已选中的对象列表
   * @returns 
   */
  getCheckedTreeById (data, list, checkedList) {
    data.forEach((item) => {
      if (list.filter((it) => { return it.toString() == item['id'].toString() }).length > 0) {
        item.checked = true
        item.selected = true
        checkedList.push(item)
      } else {
        item.checked = false
        item.selected = false
      }
      if (item.children && item.children.length) {
        item.children = this.getCheckedTreeById(item.children, list, checkedList)
      }
    })
    return data
  },

  /**
   * 获取满足条件的树列表下面的所有target字段
   * @param {*} data 
   * @param {*} key 
   * @param {*} target 
   * @param {*} outList 
   * @returns 
   */
  getUnCheckedList (data, key, target, outList) {
    data.forEach((item) => {
      if (!item[key]) {
        outList.push(item[target])
      }
      if (item.children && item.children.length) {
        this.getUnCheckedList(item.children, key, target, outList)
      }
    })
    return outList
  },

}